/**
 * 计算对数
 * @param base 底数
 * @param truth 真数
 */
export function log(base: number, truth: number) {
    return Math.log(truth) / Math.log(base)
}